<template>
  <div>
    <el-card class="box-card user-base-info">
      <el-row>
        <el-col :span="4">姓名：{{ borrowerInfo.name }}</el-col>
        <el-col :span="4">性别：{{ borrowerInfo.sex === '0' ? '男' : borrowerInfo.sex === '1' ? '女' : '' }}</el-col>
        <el-col :span="4">身份证号码：{{ borrowerInfo.idNumber }}</el-col>
        <el-col :span="4">年龄：{{ borrowerInfo.age }}</el-col>
        <el-col :span="4">婚姻情况：{{ getHuny(borrowerInfo.marital) }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">最高学历：{{ onHighestEducationName(borrowerInfo.education) }}</el-col>
        <el-col :span="4">手机号码：{{ borrowerInfo.phone }}</el-col>
        <el-col :span="4">客户第二手机号码：{{ borrowerInfo.secondPhoneNumber }}</el-col>
        <el-col :span="4">家庭电话：{{ borrowerInfo.homePhoneNumber }}</el-col>
        <el-col :span="8">家庭住址：{{ borrowerInfo.homeAddress }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8">户籍地址：{{ borrowerInfo.registeredAddress }}</el-col>
        <el-col :span="4">职业类型：{{ borrowerInfo.occupation == 0 ? '受薪人士' : borrowerInfo.occupation == 1 ? '自雇人士' : '其他'
          }}</el-col>
        <el-col :span="4">公司名称：{{ borrowerInfo.companyName }}</el-col>
        <el-col :span="4">公司地址：{{ borrowerInfo.companyAddr }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">开户行：{{ borrowerInfo.bank }}</el-col>
        <el-col :span="4">账号：{{ borrowerInfo.accountNumber }}</el-col>
        <el-col :span="4">预留手机号：{{ borrowerInfo.reservedPhoneNumber }}</el-col>
        <el-col :span="4">商品/服务：{{ borrowerInfo.projectName }}</el-col>
      </el-row>
      <el-row style="margin-top:20px ;">
        <div class="label-wrapper">
          <el-tag v-for="(item, index) in contactStatusList" :key="index">{{ item.name }}</el-tag>
          <el-tag v-for="(item, index) in task_label" :key="index">{{ item.name }}</el-tag>
          <el-tag v-if="check_list && check_list.length>0">对私放款</el-tag>
          <el-tag v-for="(item, index) in check_list" :key="index">{{ item.value }}</el-tag>
        </div>
      </el-row>
    </el-card>
    <el-table :data="tableData" class="loan-base-info" border highlight-current-row style="width: 100%">
      <el-table-column prop="contractNumber" label="合同编号" width="210" />
      <el-table-column prop="taskStatus" label="案件状态" />
      <el-table-column prop="businessType" label="业务类型" />
      <el-table-column prop="productName" label="产品" />
      <el-table-column prop="applyChannel" label="进件渠道" />
      <el-table-column prop="merchantName" label="商户简称" min-width="110" />
      <el-table-column prop="stopUser" label="驻点姓名" />
      <el-table-column prop="fundName" label="资方" />
      <el-table-column prop="loanTime" label="放款时间" width="110">
        <template slot-scope="scope">
          {{ scope.row.loanTime.substr(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column prop="contractAmount" label="合同金额" />
      <el-table-column prop="overdueDate" label="最早逾期账期" width="120" />
      <el-table-column prop="overdueDays" label="逾期天数" />
      <el-table-column prop="overduePrincipal" label="逾期本金" />
      <el-table-column prop="overdueInterest" label="逾期利息" />
      <el-table-column prop="overdueServiceFee" label="逾期服务费" width="100" />
      <el-table-column prop="penalty" label="罚息" />
      <el-table-column prop="defaultFee" label="违约金" />
      <el-table-column prop="lateFee" label="滞纳金" />
      <el-table-column prop="overdueAmount" label="逾期金额" />
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getAfdDictionaryList } from '@/api/manage'

import {
  getTaskCheckList
} from "@/api/task.js";

export default {
  name: 'itemUserInfo',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      contactStatusList: [],
      task_label: [],
      check_list: [],
      jiaoyList: [],
      hunyList: []
    }
  },
  computed: {
    ...mapGetters([
      'borrowerInfo',
      'taskLabel'
    ])
  },
  watch: {
    borrowerInfo(val) {
      this.tableData = []
      this.tableData.push({
        contractNumber: val.contractNumber,
        taskStatus: val.taskStatus,
        businessType: val.businessType === '1' ? '爱分担' : val.businessType === '2' ? '分担宝' : val.businessType === '3' ? '助贷通道' : val.businessType === '4' ? '好易付' : val.businessType === '5' ? '实物租赁' : '',
        productName: val.productName,
        applyChannel: val.applyChannel === '1' ? '申城' : val.applyChannel === '2' ? '渠道2' : '',
        merchantName: val.merchantName,
        fundName: val.fundName,
        loanTime: val.loanTime,
        contractAmount: val.contractAmount,
        taskCreatedAt: val.taskCreatedAt,
        overdueDate: val.overdueDate,
        overdueDays: val.overdueDays,
        overduePrincipal: val.overduePrincipal,
        overdueInterest: val.overdueInterest,
        overdueServiceFee: val.overdueServiceFee,
        penalty: val.penalty,
        defaultFee: val.defaultFee,
        lateFee: val.lateFee,
        overdueAmount: val.overdueAmount,
        stopUser: val.stopUser
      })
    },
    taskLabel(val) {
      this.contactStatusList = []
      this.task_label = []
      // 有code为联系状态，否则为标签
      val.map((item) => {
        if (item.code) {
          this.contactStatusList.push(item)
        } else {
          this.task_label.push(item)
        }
      })
    }
  },
  async created() {
    await this.fetchBorrowerInfo({ taskId: this.taskId })
    await getTaskCheckList(this.taskId).then(res => {
      this.check_list = res.data
    })
    const statusListRes = await getAfdDictionaryList('9109')
    statusListRes.data.map((item) => {
      this.jiaoyList.push({
        label: item.dictLabel,
        value: Number(item.dictValue)
      })
    })
    const hunyListRes = await getAfdDictionaryList('9108')
    hunyListRes.data.map((item) => {
      this.hunyList.push({
        label: item.dictLabel,
        value: Number(item.dictValue)
      })
    })
  },
  methods: {
    ...mapActions([
      'fetchBorrowerInfo'
    ]),
    onHighestEducationName (value) {
      let str = ''
      if (value === '00') {
        str = '硕士及以上'
      } else if (value === '10') {
        str = '本科'
      } else if (value === '20') {
        str = '大专'
      } else if (value === '30') {
        str = '高中'
      } else if (value === '40') {
        str = '初中及以下'
      }
      return str
    },
    getHuny(type) {
      const list = this.hunyList.filter((item) => item.value === Number(type))
      if (list.length > 0) {
        return list[0].label
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-base-info {
  font-size: 16px;
  line-height: 20px;
}

.label-wrapper {

  span {
    margin-right: 10px;
  }
}
</style>
